/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B030080 得意先元帳出力
 */
import {
  SText,
  SCodeSelect,
  SFrame,
  SLabel,
  SNumberField,
  STextField,
  SFileButton,
  msgState,
} from "components";
import {
  B030080ShutsuryokuKbn,
  B030080Urikakejoken,
  getSCode,
  SCode,
} from "messages/codes";
import { labels } from "messages/labels";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { focusState, useFocus } from "states";
import { download, yearMonth } from "../../services";
import { useNavigate } from "react-router-dom";
import {
  B000130BumonNmrFrom,
  B000130BumonNmrTo,
  B000140ShainNmFrom,
  B000140ShainNmTo,
  B000150UrikakeNmrFrom,
  B000150UrikakeNmrTo,
  catchFileError,
} from "clients/rest";
import { B030080GetExcel, B030080Request } from "clients/rest/b030/B030080";
import { B000150 } from "pages";
import { calledParam } from "services/codes";
import { getClientMessage } from "messages";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  urikakeYm: string;
  bumonCdFrom: string;
  bumonNmrFrom: string;
  bumonCdTo: string;
  bumonNmrTo: string;
  shainCdFrom: string;
  shainNmFrom: string;
  shainCdTo: string;
  shainNmTo: string;
  urikakeCdFrom: string;
  urikakeshitenCdFrom: string;
  urikakeNmrFrom: string;
  urikakeCdTo: string;
  urikakeshitenCdTo: string;
  urikakeNmrTo: string;
  urikakejoken: SCode;
  shutsuryokuKbn: SCode;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  urikakeYm: yearMonth(),
  bumonCdFrom: "",
  bumonNmrFrom: "",
  bumonCdTo: "",
  bumonNmrTo: "",
  shainCdFrom: "",
  shainNmFrom: "",
  shainCdTo: "",
  shainNmTo: "",
  urikakeCdFrom: "",
  urikakeshitenCdFrom: "",
  urikakeNmrFrom: "",
  urikakeCdTo: "",
  urikakeshitenCdTo: "",
  urikakeNmrTo: "",
  urikakejoken: getSCode(B030080Urikakejoken, "9"),
  shutsuryokuKbn: getSCode(B030080ShutsuryokuKbn, "0"),
};

const focusId = "B030080";

// B030080 得意先元帳出力
export const B030080 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 画面遷移
  const navigate = useNavigate();

  // 初期表示イベント
  useEffect(() => {
    focus(1);
  }, []);

  // Excel出力ボタンクリックイベント
  const handleClickExcelButton = () => {
    // フィールドの値取得
    const fields = methods.getValues();

    // リクエスト作成
    const param: B030080Request = {
      urikakeYm: fields.urikakeYm!,
      bumonCdFrom: fields.bumonCdFrom,
      bumonNmrFrom: fields.bumonNmrFrom,
      bumonCdTo: fields.bumonCdTo,
      bumonNmrTo: fields.bumonNmrTo,
      shainCdFrom: fields.shainCdFrom,
      shainNmFrom: fields.shainNmFrom,
      shainCdTo: fields.shainCdTo,
      shainNmTo: fields.shainNmTo,
      urikakeCdFrom: fields.urikakeCdFrom,
      urikakeshitenCdFrom: fields.urikakeshitenCdFrom,
      urikakeNmrFrom: fields.urikakeNmrFrom,
      urikakeCdTo: fields.urikakeCdTo,
      urikakeshitenCdTo: fields.urikakeshitenCdTo,
      urikakeNmrTo: fields.urikakeNmrTo,
      urikakejoken: fields.urikakejoken?.value!,
      shutsuryokuKbn: fields.shutsuryokuKbn?.value!,
    };

    B030080GetExcel(param)
      .then((response) => {
        download(response);
        setMsg(getClientMessage("B030080_001"));
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="得意先元帳出力"
          gridTemplateColumns="7rem 6rem 4rem 10rem 5rem 7rem 4rem 8rem "
        >
          <SLabel required> 対象年月</SLabel>
          <SNumberField
            name="urikakeYm"
            label="対象年月"
            code
            required
            gridColumn="span 2"
            size={6}
            {...register(1)}
          />
          <SText align="left">月度</SText>

          <SLabel gridColumn="1"> 売掛担当部門</SLabel>
          <SNumberField
            name="bumonCdFrom"
            label="売掛担当部門コード（From）"
            code
            size={6}
            gridColumn="span 2"
            onBlur={() => B000130BumonNmrFrom(methods, navigate, setMsg)}
            {...register(2)}
          />
          <STextField
            name="bumonNmrFrom"
            label="売掛担当部門名称（From）	"
            size={20}
            disabled
          />
          <SText>~</SText>
          <SNumberField
            name="bumonCdTo"
            label="売掛担当部門コード（To）"
            code
            size={6}
            gridColumn="span 2"
            onBlur={() => B000130BumonNmrTo(methods, navigate, setMsg)}
            {...register(3)}
          />
          <STextField
            name="bumonNmrTo"
            label="売掛担当部門名称（To）"
            size={20}
            disabled
          />

          <SLabel gridColumn="1"> 売掛担当者</SLabel>
          <SNumberField
            name="shainCdFrom"
            label="売掛担当者コード（From）"
            code
            size={7}
            gridColumn="span 2"
            onBlur={() => B000140ShainNmFrom(methods, navigate, setMsg)}
            {...register(4)}
          />
          <STextField
            name="shainNmFrom"
            label="売掛担当者名称（From）"
            size={40}
            disabled
          />
          <SText>~</SText>
          <SNumberField
            name="shainCdTo"
            label="売掛担当者コード（To）"
            code
            size={7}
            gridColumn="span 2"
            onBlur={() => B000140ShainNmTo(methods, navigate, setMsg)}
            {...register(5)}
          />
          <STextField
            name="shainNmTo"
            label="売掛担当者名称（To）"
            size={40}
            disabled
          />

          <SLabel gridColumn="1"> 売掛先</SLabel>
          <SNumberField
            name="urikakeCdFrom"
            label="売掛先コード（From）"
            code
            size={6}
            onBlur={() => B000150UrikakeNmrFrom(methods, navigate, setMsg)}
            {...register(6)}
          />
          <SNumberField
            name="urikakeshitenCdFrom"
            label="売掛先支店コード（From）"
            code
            size={4}
            dialog={<B000150 calledParam={calledParam.urikake} />}
            handleSubmit={(data: any) => {
              methods.setValue("urikakeCdFrom", data.tokuiCd);
              methods.setValue("urikakeshitenCdFrom", data.tokuishitenCd);
              methods.setValue("urikakeNmrFrom", data.tokuiNmr);
            }}
            onBlur={() => B000150UrikakeNmrFrom(methods, navigate, setMsg)}
            {...register(7)}
          />
          <STextField
            name="urikakeNmrFrom"
            label="売掛先名称（From）"
            size={24}
            disabled
          />
          <SText>~</SText>
          <SNumberField
            name="urikakeCdTo"
            label="売掛先コード（To）"
            code
            size={6}
            onBlur={() => B000150UrikakeNmrTo(methods, navigate, setMsg)}
            {...register(8)}
          />
          <SNumberField
            name="urikakeshitenCdTo"
            label="売掛先支店コード（To）"
            code
            size={4}
            dialog={<B000150 calledParam={calledParam.urikake} />}
            handleSubmit={(data: any) => {
              methods.setValue("urikakeCdTo", data.tokuiCd);
              methods.setValue("urikakeshitenCdTo", data.tokuishitenCd);
              methods.setValue("urikakeNmrTo", data.tokuiNmr);
            }}
            onBlur={() => B000150UrikakeNmrTo(methods, navigate, setMsg)}
            {...register(9)}
          />
          <STextField
            name="urikakeNmrTo"
            label="売掛先名称（To）"
            size={24}
            disabled
          />

          <SLabel>売掛先出力条件</SLabel>
          <SCodeSelect
            name="urikakejoken"
            label="	売掛先条件"
            options={B030080Urikakejoken}
            gridColumn="span 2"
            required
            {...register(10)}
          />

          <SLabel gridColumn="1">出力方法</SLabel>
          <SCodeSelect
            name="shutsuryokuKbn"
            label="出力方法"
            options={B030080ShutsuryokuKbn}
            gridColumn="span 2"
            required
            {...register(11)}
          />

          <SFileButton
            label={labels.buttons.excel}
            onClick={handleClickExcelButton}
            gridColumn={5}
            gridRow={8}
            {...register(12)}
          />
        </SFrame>
      </FormProvider>
    </>
  );
};
